function initCarouselKeyboardNavigation(carousel) {
    const focusableSelector = 'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';
    let pendingFocusDirection = null;

    carousel.on('keydown', '.aemproduct__carousel-item *', function (e) {
        if (e.key !== 'Tab') return;

        const slick = carousel.slick('getSlick');
        const slidesToShow = slick.options.slidesToShow || 1;
        const firstVisible = slick.currentSlide;
        const lastVisible = firstVisible + slidesToShow - 1;
        const totalSlides = slick.slideCount;
        const isShift = e.shiftKey;

        // Get all non-cloned slides
        const items = carousel.find('.aemproduct__carousel-item').filter((_, el) => !$(el).hasClass('slick-cloned'));

        // Filter slides that are currently visible
        const visibleSlides = items.slice(firstVisible, lastVisible + 1);
        const focusableInVisible = visibleSlides.find(focusableSelector).filter((_, el) => el.offsetParent !== null);
        const currentFocusIndex = focusableInVisible.index(document.activeElement);

         // If Tab and currently on last focusable item, go to next slide
        if (!isShift && currentFocusIndex === focusableInVisible.length - 1 && lastVisible < totalSlides - 1) {
            e.preventDefault();
            pendingFocusDirection = 'forward';
            slick.slickNext();
        }
        
        // If Shift+Tab and currently on first focusable item, go to previous slide
        else if (isShift && currentFocusIndex === 0 && firstVisible > 0) {
            e.preventDefault();
            pendingFocusDirection = 'backward';
            slick.slickPrev();
        }
    });
    // Focus element only after the slide animation completes
    carousel.on('afterChange', function (event, slick, currentSlide) {
        if (!pendingFocusDirection) return;
        const items = carousel.find('.aemproduct__carousel-item').filter((_, el) => !$(el).hasClass('slick-cloned'));
        const slidesToShow = slick.options.slidesToShow || 1;
        const visibleSlides = items.slice(currentSlide, currentSlide + slidesToShow);
        const focusableInVisible = visibleSlides.find(focusableSelector).filter((_, el) => el.offsetParent !== null);
        if (pendingFocusDirection === 'forward') {
            focusableInVisible.first().focus();
        } else if (pendingFocusDirection === 'backward') {
            focusableInVisible.last().focus();
        }
        pendingFocusDirection = null;
    });
}




window.addEventListener('load', event => {
    var seasonalCarousel = $('.seasonal__carousel');
    var aemproductCarousels = $('.aemproduct__carousel');
    try {
        const customPaging = (slider, i) => {
            return `<button type="button" aria-label="Go to slide ${i + 1}">${i + 1}</button>`;
        };

        seasonalCarousel?.each(function (index, element) {
            var slider = $(this);
            var prevArrowButton = slider.closest('.block--seasonal').find('.seasonal__action-prev');
            var nextArrowButton = slider.closest('.block--seasonal').find('.seasonal__action-next');
            slider?.slick({
                dots: true,
                infinite: false,
                slidesToShow: 4,
                slidesToScroll: 4,
                prevArrow: prevArrowButton,
                nextArrow: nextArrowButton,
                accessibility: false,
                responsive: [
                    {
                        breakpoint: 767.98,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3
                        }
                    },
                    {
                        breakpoint: 639.98,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    }
                ],
                customPaging
            });
        });

        var seasonalCarouselItems = document?.querySelectorAll('.seasonal__carousel-item');
        var handleTabindex = function (elements) {
            [...elements]?.forEach(seasonalCarouselItem => {
                seasonalCarouselItem.tabIndex = '0';
                seasonalCarouselItem.ariaHidden = 'false';
            });
        };
        handleTabindex(seasonalCarouselItems);

        if (aemproductCarousels) {
            function toggleDotsAndActions(slick, sliderActions, slider) {
                var dotsLength = slider?.find('ul.slick-dots li').length;
                var dotsElement = $(slick.$dots);
                if (dotsLength <= 1) {
                    dotsElement.hide(); // Hide dots
                    sliderActions.hide();
                } else {
                    dotsElement.show(); // Show dots
                    sliderActions.css('display', 'flex');
                }
            }

            aemproductCarousels?.each(function (index, element) {
                var aemproductCarousel = $(this);

                var aemproductPrevArrowButton = aemproductCarousel
                    .closest('.block--aemproduct')
                    .find('.aemproduct__action-prev');

                var aemproductNextArrowButton = aemproductCarousel
                    .closest('.block--aemproduct')
                    .find('.aemproduct__action-next');

                var aemproductSliderActions = aemproductCarousel
                    .closest('.block--aemproduct')
                    .find('.aemproduct__carousel-actions');

                aemproductCarousel.on('init', function (event, slick) {
                    toggleDotsAndActions(slick, aemproductSliderActions, aemproductCarousel);
                });

                aemproductCarousel?.slick({
                    dots: true,
                    infinite: false,
                    slidesToShow: 6,
                    slidesToScroll: 6,
                    prevArrow: aemproductPrevArrowButton,
                    nextArrow: aemproductNextArrowButton,
                    accessibility: false,
                    responsive: [
                        {
                            breakpoint: 1024.98,
                            settings: {
                                slidesToShow: 4,
                                slidesToScroll: 4
                            }
                        },
                        {
                            breakpoint: 767.98,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 3
                            }
                        },
                        {
                            breakpoint: 639.98,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2
                            }
                        }
                    ],
                    customPaging
                });
                aemproductCarousel.on('afterChange', function (event, slick, currentSlide, nextSlide) {
                    toggleDotsAndActions(slick, aemproductSliderActions, aemproductCarousel);
                });
                initCarouselKeyboardNavigation(aemproductCarousel);
            });
        }
    } catch (error) {
        console.error('An error occurred while initializing the slick slider:', error);
    }
});

window.slickCarousalRefresh = (selector) => {
    let element = $(selector);
    if (element && element.length) {
        $(element).slick('refresh');
    }
};
   
   